import { isMobile, isBrowser, isTablet } from "react-device-detect";
import { Smartphone, Monitor } from "lucide-react";

function MobileOnlyScreen() {
  // Check if it's a browser (not a mobile app) and not a mobile/tablet device
  // This prevents desktop browsers from accessing, even with mobile emulation
  const isDesktopBrowser = isBrowser && !isMobile && !isTablet;

  // If mobile or tablet, don't render anything (let the app through)
  if (!isDesktopBrowser) {
    return null;
  }

  // Show desktop warning screen
  return (
    <div className="fixed inset-0 z-50 bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center">
        {/* Icon */}
        <div className="relative mb-6">
          <div className="w-32 h-32 mx-auto bg-gradient-to-br from-red-100 to-orange-100 rounded-full flex items-center justify-center">
            <Monitor className="w-16 h-16 text-red-500 absolute" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 border-4 border-red-500 rounded-full animate-ping opacity-75"></div>
            </div>
            <Smartphone className="w-12 h-12 text-green-500 absolute -bottom-2 -right-2 bg-white rounded-full p-2 shadow-lg" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Mobile Only App
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-6 text-lg">
          This application is designed exclusively for mobile devices.
        </p>

        {/* Instructions */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 mb-6">
          <p className="text-gray-800 font-semibold mb-3">
            To access this app:
          </p>
          <div className="space-y-3 text-left">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                1
              </div>
              <p className="text-gray-700 text-sm">
                Open this website on your mobile phone or tablet
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                2
              </div>
              <p className="text-gray-700 text-sm">
                Use your phone's browser (Chrome, Safari, etc.)
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-indigo-500 text-white rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                3
              </div>
              <p className="text-gray-700 text-sm">
                Install the app for the best experience
              </p>
            </div>
          </div>
        </div>

        {/* QR Code suggestion */}
        <div className="text-sm text-gray-500 italic">
          💡 Tip: You can scan a QR code or send the link to your mobile device
        </div>

        {/* Current URL Display */}
        <div className="mt-6 p-3 bg-gray-100 rounded-xl">
          <p className="text-xs text-gray-500 mb-1">Current URL:</p>
          <p className="text-sm font-mono text-gray-700 break-all">
            {window.location.href}
          </p>
        </div>
      </div>
    </div>
  );
}

export default MobileOnlyScreen;
